import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindMariageLanding2Content($id: String!) {
    findMariageLanding2Content(id: $id) {
        data {
            pageTitle { iv }      
            seoDescription { iv }
            seoKeywords { iv }
            seoThumbnail {
                iv {
                    url
                }
            }
            intro {
                iv { id }
            }
            carrousel {
                iv { id }
            }
            news {
                iv { id }
            }
            promo {
                iv { id }
            }
            mention {
                iv { id }
            }
            rubricTitle { iv }
            rubricTitleFontSize { iv }
            rubricSubtitle { iv }
            rubricSubtitleFontSize { iv }
            rubricColor { iv }
            rubricItems {
                iv {
                    picture {
                        url
                        fileSize
                    }
                    pictureLink
                    text
                    highlight
                }
            }
        }
    }
}
`,
]);
